import CollectionService from '@boServices/collectionService';
import TagService from '@boServices/tagService';
import TestService from '@boServices/testService';
import { useEffect, useState } from 'react';

const collectionService = new CollectionService();
const tagService = new TagService();
const testService = new TestService();

const languageToOption = (l) => ({ value: l.id, label: l.nom });
const levelToOption = (l) => ({ value: l.id, label: l.nom });

const useCollectionOptions = () => {
    const [tagsOptions, setTagsOptions] = useState([]);
    const [languagesOptions, setLanguagesOptions] = useState([]);
    const [levelsOptions, setLevelsOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const tagsAndLanguages = Promise.all([tagService.getTags(), collectionService.getLangues()])
            .then(([tagsData, languagesData]) => {
                setTagsOptions({
                    typology: tagsData.filter((tag) => tag.type === 'typology'),
                    domain: tagsData.filter((tag) => tag.type === 'domain'),
                    family: tagsData.filter((tag) => tag.type === 'family'),
                });
                setLanguagesOptions((Array.isArray(languagesData) ? languagesData : []).map(languageToOption));
            })
            .catch(setError);

        // The levels load on their own: only the test forms need them, so a failing request must not take the
        // tags and the languages (the collection filters) down with it.
        const levels = testService
            .getLevels()
            .then((levelsData) => setLevelsOptions((Array.isArray(levelsData) ? levelsData : []).map(levelToOption)))
            .catch(() => {});

        Promise.all([tagsAndLanguages, levels]).finally(() => setLoading(false));
    }, []);

    return { tagsOptions, languagesOptions, levelsOptions, loading, error };
};

export default useCollectionOptions;
